/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
export const environment = {
  production: true,
  apiUrl: 'https://homologacao.novo.renointeligencia.com/api/',
  siteUrl: 'https://homologacao.novo.renointeligencia.com',
  hubUrl: 'https://homologacao-hub.renointeligencia.com', // URL do Hub de Notificações
  clarityProjectId: 'uy9utrdszw' // Staging/Homologação
};
